<template>
    <div class="welfare">
         <img src="../assets/welfare/header.png" alt style="width:100%;height:210px"/>
         <div id="salary"><component :is="Salary"></component></div>
         <div id="guarantee"><component :is="Guarantee"></component></div>
         <div id="colorfulLife"><component :is="ColorfulLife"></component></div>
         <div id="familyBenefits"><component :is="FamilyBenefits"></component></div>
    </div>
</template>
<style scoped>
</style>
<script>
import SalaryVue from './Salary.vue';
import GuaranteeVue from './Guarantee.vue';
import ColorfulLifeVue from './ColorfulLife.vue';
import FamilyBenefitsVue from './FamilyBenefits.vue';
export default {
  props:['byScroll','selecetdMenu'],
	watch: {
	  
        byScroll: function (val) {
          this.byScroll = val;
	      },
        selecetdMenu: function (val) {   
          if(!this.byScroll){
            this.scrollTotarget(val)
          }   
	      }
    },
    data () {
    return {
     msg: '员工福利',
     Salary:SalaryVue,
     Guarantee:GuaranteeVue,
     ColorfulLife:ColorfulLifeVue,
     FamilyBenefits:FamilyBenefitsVue,
    };
    },
    
    mounted () {
      var selecetdMenu = this.$route.params.selecetdMenu;
      console.log("mounted 跳转并传参"+selecetdMenu);
      if(selecetdMenu !=null){
        this.scrollTotarget(selecetdMenu)
      }
    },
    
    activated () {
      var selecetdMenu = this.$route.params.selecetdMenu;
      console.log("activated 跳转并传参"+selecetdMenu);
      if(selecetdMenu !=null){
        this.scrollTotarget(selecetdMenu)
      }
    },
    methods:{
      scrollTotarget(val){
            let  target = 'salary';
            if(val==1){
              target   = 'guarantee';
            }else if(val==2){
              target   = 'colorfulLife';
            }else if(val==3){
                target   = 'familyBenefits';
            }
	       		document.getElementById(target).scrollIntoView();
      }
      
    }

}
</script>


// WEBPACK FOOTER //
// src/components/Welfare.vue